import { p as i } from "../../plugin-CBs7of0e.js";
import r from "../colors/index.js";
const g = i(({ addUtilities: e }) => {
  e({
    ".bg-gradient-primary-turq-600": {
      background: `linear-gradient(116deg, ${r.primary.DEFAULT} 1.95%, ${r.turquoise[600]} 99.03%)`
    },
    ".bg-gradient-blue-700-blue-900": {
      background: `linear-gradient(116deg, ${r.blue[700]} 1.1%, ${r.blue[900]} 99.2%)`
    }
  });
});
export {
  g as default
};
